/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerSignupProfileDraftCategories
 */
export interface FreelancerSignupProfileDraftCategories {
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerSignupProfileDraftCategories
     */
    selectedCategories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupProfileDraftCategories
     */
    preferredCategory: string;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerSignupProfileDraftCategories
     */
    selectedByPredictions: boolean;
}

/**
 * Check if a given object implements the FreelancerSignupProfileDraftCategories interface.
 */
export function instanceOfFreelancerSignupProfileDraftCategories(value: object): value is FreelancerSignupProfileDraftCategories {
    if (!('selectedCategories' in value) || value['selectedCategories'] === undefined) return false;
    if (!('preferredCategory' in value) || value['preferredCategory'] === undefined) return false;
    if (!('selectedByPredictions' in value) || value['selectedByPredictions'] === undefined) return false;
    return true;
}

export function FreelancerSignupProfileDraftCategoriesFromJSON(json: any): FreelancerSignupProfileDraftCategories {
    return FreelancerSignupProfileDraftCategoriesFromJSONTyped(json, false);
}

export function FreelancerSignupProfileDraftCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerSignupProfileDraftCategories {
    if (json == null) {
        return json;
    }
    return {
        
        'selectedCategories': json['selectedCategories'],
        'preferredCategory': json['preferredCategory'],
        'selectedByPredictions': json['selectedByPredictions'],
    };
}

export function FreelancerSignupProfileDraftCategoriesToJSON(value?: FreelancerSignupProfileDraftCategories | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'selectedCategories': value['selectedCategories'],
        'preferredCategory': value['preferredCategory'],
        'selectedByPredictions': value['selectedByPredictions'],
    };
}

